import { useQuery } from "@tanstack/react-query";
import { Entry } from "../models/Entry";
import { getEntries } from "../repository/LogbookRepository";

type UseEntriesProps = {
	shiftId?: number;
	sectionIds?: number[];
};

export const useEntries = ({ shiftId, sectionIds }: UseEntriesProps) => {
	return useQuery<Entry[], Error>({
		queryKey: ["entries", shiftId, sectionIds],
		queryFn: ({ signal }) => getEntries({ shiftId, sectionIds }, signal),
	});
};

export const routeLogbookEntry = "/logbook/entry";
